import { Feature, Map } from "ol";
import { Point, Circle } from "ol/geom";
import { Collection } from "ol";
import { Modify } from "ol/interaction";
import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style";
import { Vector as VectorSource } from "ol/source";
import { Vector as VectorLayer } from "ol/layer";

const centerGraphicStyle = new Style({
    image: new CircleStyle({
        radius: 6,
        fill: new Fill({ color: "#fff" }),
        stroke: new Stroke({ color: "blue", width: 4 })
    })
});

const outlineBigStyle = new Style({
    fill: new Fill({ color: "#0000ff16" }),
    stroke: new Stroke({ color: "blue", width: 2 })
});
const outlineSmallStyle = new Style({
    stroke: new Stroke({ color: "Red", width: 2 })
});

let modifyInteraction: Modify;
let interval;

const pointLayer = new VectorLayer();

const centerGraphic = new Feature({ id: "centerGraphic" });
centerGraphic.setStyle(centerGraphicStyle);

const outlineBig = new Feature({ id: "outlineBig" });
outlineBig.setStyle(outlineBigStyle);
const outlineSmall = new Feature({ id: "outlineSmall" });
outlineSmall.setStyle(outlineSmallStyle);

export const useSimulator = (
    map: Map,
    isOn: boolean,
    approachRadius?: number,
    leaveRadius?: number,
    onSuccess?: CallableFunction
): void => {
    let center = map.getView().getCenter();

    const startSimulator = () => {
        placeMarker();
        addModifyInteraction();
        interval = setInterval(() => onSuccess({ coords: { latitude: center[0], longitude: center[1] } }, true), 1000);
    };

    const stopSimulator = () => {
        pointLayer.getSource() && removeMarker();
        removeModifyInteraction();
        clearInterval(interval);
    };

    const placeMarker = () => {
        const centerPoint = new Point(map.getView().getCenter());
        const outlineBigCircle = new Circle(map.getView().getCenter(), leaveRadius);
        const outlineSmallCircle = new Circle(map.getView().getCenter(), approachRadius);
        centerGraphic.setGeometry(centerPoint);
        outlineBig.setGeometry(outlineBigCircle);
        outlineSmall.setGeometry(outlineSmallCircle);
        pointLayer.setMap(map);
        pointLayer.setSource(new VectorSource({ features: [centerGraphic, outlineBig, outlineSmall] }));

        centerGraphic.on("change", followCenter);
    };

    const removeMarker = () => {
        centerGraphic.un("change", followCenter);
        pointLayer.getSource().clear();
        pointLayer.setMap(null);
    };

    const addModifyInteraction = () => {
        removeModifyInteraction();
        const featureCollection = new Collection();
        featureCollection.push(centerGraphic);
        modifyInteraction = new Modify({
            features: featureCollection,
            pixelTolerance: 15,
            style: (feature: Feature) =>
                feature.getId() === "centerGraphic"
                    ? centerGraphicStyle
                    : "outlineBig"
                    ? outlineBigStyle
                    : "outlineSmall"
        });
        map.addInteraction(modifyInteraction);
    };

    const removeModifyInteraction = () => {
        map.removeInteraction(modifyInteraction);
        modifyInteraction = null;
        centerGraphic;
    };

    const followCenter = (e) => {
        center = e.target.getGeometry().getCoordinates();
        outlineBig.getGeometry().setCenter(center);
        outlineSmall.getGeometry().setCenter(center);
    };

    isOn ? startSimulator() : stopSimulator();
};
